import CustomText from "../atomic/CustomText";
import Button from "../organism/Button";
import FileDetail from "./FileDetail";

function MultipleFileUploader({
  handleDrop,
  handleRemove,
  files,
  inputRef,
  hideText,
  customText,
  buttonText,
  buttonClass,
  hideUploaderText = false,
  uploadButtonContainerClassName = "",
}: {
  handleDrop: any;
  handleRemove: Function;
  files: any[];
  inputRef: any;
  hideText?: boolean;
  customText?: string;
  buttonText?: string;
  buttonClass?: string;
  hideUploaderText?: boolean;
  uploadButtonContainerClassName?: string;
}) {
  return (
    <div
      onDragOver={(e) => e.preventDefault()}
      onDragEnter={(e) => e.preventDefault()}
      onDragLeave={(e) => e.preventDefault()}
      onDrop={handleDrop}
    >
      {hideText ? null : (
        <CustomText
        text={
          !!customText
            ? customText
            : "Please upload any additional file(s) required for transmission to Clinical Services. Accepted formats include .png, .jpeg, .pdf, and .doc/*, with a maximum file size of 50 MB."
        }
        fontWeight="font-normal"
        className="text-royalBlue max-w-[500px]"
      />
      )}
      <div className="flex flex-wrap">
        {files?.map((file: any, mainIndex: number) => (
          <FileDetail key={file.name} doc={file} handleRemove={handleRemove(mainIndex)} />
        ))}
      </div>
      <div
        className={`bg-sideNavGray border-dashed border-roundedInputBorder rounded-[8px] p-3 border-2 mt-2 flex flex-col items-center max-w-[200px] ${uploadButtonContainerClassName}`}
      >
        {!hideUploaderText && (
          <h4 className="my-2 text-xs text-center">
            Upload or drag and drop files
          </h4>
        )}
        <Button
          buttonTheme="secondary"
          type="button"
          textInformation={{
            text: !!buttonText ? buttonText : "choose more files",
            fontWeight: "font-semibold",
          }}
          className={`bg-white ${buttonClass}`}
          onClick={() => inputRef.current.click()}
        />
      </div>
    </div>
  );
}

export default MultipleFileUploader;
